import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseCCCTerminalTypesAdapter = getAdapter({ idFieldName: 'value' });

const warehouseCCCTerminalTypesSlice = createSlice({
  name: 'warehouseCCCTerminalTypes',
  initialState: warehouseCCCTerminalTypesAdapter.getInitialState(),
  reducers: {
    setWarehouseCCCTerminalTypes: (state, { payload: { cccTerminalTypes } }) => {
      warehouseCCCTerminalTypesAdapter.setAll(state, cccTerminalTypes);
    },
  },
});

const selectors = warehouseCCCTerminalTypesAdapter.getSelectors(({ warehouseCCCTerminalTypes }) => warehouseCCCTerminalTypes);

export const getWarehouseCCCTerminalTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseCCCTerminalTypes = (state) => getWarehouseCCCTerminalTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseCCCTerminalTypes,
} = warehouseCCCTerminalTypesSlice.actions;

export default warehouseCCCTerminalTypesSlice.reducer;
